module.exports = __webpack_public_path__ + "fonts/TTFirs-Thin.3d27f8f7.woff2";